module.exports = __webpack_public_path__ + "3add08e1b890d3856f3d2fe5bd10c744.MP3";